// extracted by mini-css-extract-plugin
export default {"title__container":"Questions_title__container__MIYnX","questions__container":"Questions_questions__container__IPwIi"};